const blendTabs = document.querySelectorAll(".blend-tab");
const productFields = {
  kicker: document.querySelector("[data-product-kicker]"),
  title: document.querySelector("[data-product-title]"),
  description: document.querySelector("[data-product-description]"),
  roast: document.querySelector("[data-product-roast]"),
  flavour: document.querySelector("[data-product-flavour]"),
};
const productImage = document.querySelector("[data-product-image]");
const variantInput = document.querySelector("[data-variant-input]");
const productForm = document.querySelector("[data-product-form]");
const productSubmit = document.querySelector(".shopify-button");

function setBlend(tab) {
  if (!tab) return;

  Object.entries(productFields).forEach(([field, node]) => {
    if (node) node.textContent = tab.dataset[field] || "";
  });

  if (productImage) {
    productImage.src = tab.dataset.image || "";
    productImage.alt = tab.dataset.imageAlt || "";
  }

  if (variantInput) {
    variantInput.value = tab.dataset.variantId || "";
  }

  if (productSubmit) {
    productSubmit.disabled = !tab.dataset.variantId;
  }

  blendTabs.forEach((blendTab) => {
    blendTab.classList.toggle("active", blendTab === tab);
    blendTab.style.removeProperty("--active-blend-color");
  });

  tab.style.setProperty("--active-blend-color", tab.dataset.color || "#bfd7df");
}

blendTabs.forEach((tab) => {
  tab.addEventListener("click", () => setBlend(tab));
});

document.querySelectorAll(".info-expander").forEach((expander) => {
  expander.addEventListener("toggle", () => {
    if (!expander.open) return;

    document.querySelectorAll(".info-expander").forEach((otherExpander) => {
      if (otherExpander !== expander) {
        otherExpander.open = false;
      }
    });
  });
});

if (blendTabs.length) {
  setBlend(document.querySelector(".blend-tab.active") || blendTabs[0]);
}

if (productForm) {
  productForm.addEventListener("submit", (event) => {
    if (!variantInput || !variantInput.value) {
      event.preventDefault();
      alert("Choose Shopify products for each blend in the theme editor first.");
    }
  });
}
/* Mobile blend selector: swipe product area to change blend */
(function () {
  const tabs = Array.from(document.querySelectorAll(".blend-tab"));
  if (!tabs.length) return;

  function getActiveIndex() {
    return Math.max(
      tabs.findIndex((tab) => tab.classList.contains("active")),
      0
    );
  }

  function activateTab(index) {
    const nextTab = tabs[Math.min(Math.max(index, 0), tabs.length - 1)];
    if (!nextTab) return;

    nextTab.click();
    nextTab.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "center"
    });
  }

  document.querySelectorAll(".blend-selector, .product-panel").forEach((region) => {
    let startX = 0;
    let startY = 0;

    region.addEventListener(
      "touchstart",
      (event) => {
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
      },
      { passive: true }
    );

    region.addEventListener(
      "touchend",
      (event) => {
        const touch = event.changedTouches[0];
        const deltaX = touch.clientX - startX;
        const deltaY = touch.clientY - startY;

        if (Math.abs(deltaX) < 48 || Math.abs(deltaX) < Math.abs(deltaY) * 1.4) {
          return;
        }

        activateTab(getActiveIndex() + (deltaX < 0 ? 1 : -1));
      },
      { passive: true }
    );
  });
})();